export const ADMIN_BASE_PATH = '/bca-admin9';
export const ADMIN_LOGIN_PATH = `${ADMIN_BASE_PATH}/login`;

export function isAdminPath(pathname: string): boolean {
  return pathname.startsWith(ADMIN_BASE_PATH);
}

export function adminPath(path: string): string {
  return `${ADMIN_BASE_PATH}${path.startsWith('/') ? path : `/${path}`}`;
}
